export const clearAllBlogCache = () => {
  const deletedKeys = [];

  Object.keys(localStorage).forEach((key) => {
    const isPublishedCache = key === "publishedBlogsCache";
    const isFeaturedBlog = key === "featuredBlogCache";

    if (isPublishedCache || isFeaturedBlog) {
      localStorage.removeItem(key);
      deletedKeys.push(key);
    }
  });

  return deletedKeys;
};
